module.exports = __webpack_public_path__ + "static/media/35.b86c9790.jpg";